import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconAdbShellOutline } from '@saucelabs/ds-icons';
import { actions as modalActions } from '@saucelabs/sl-container-modal';

import { TOOLBAR_TRACKING_NAMES, trackEvent } from '../../../tracking';
import { executeADBShell } from '../../../actions';
import ExecuteADBShellModal, { EXECUTE_ADB_SHELL_MODAL_KEY } from '../../../components/MobileManualSession/ExecuteADBShellModal';
import selectors from '../selectors';
import GenericButton from './GenericButton';

const AdbShellButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    deviceToolsDisabled,
    deviceType,
    testType,
  } = useSelector(selectors.toolbarButtonSelector);

  const showAdbShellModal = () => {
    void dispatch(modalActions.showModal(EXECUTE_ADB_SHELL_MODAL_KEY));

    trackEvent(TOOLBAR_TRACKING_NAMES.ADB_SHELL, { deviceType, testType });
  };

  return (
    <>
      <ExecuteADBShellModal
        onConfirm={(command) => {
          void dispatch(executeADBShell(command));
        }}
        testType={testType}
      />

      <GenericButton
        disabled={deviceToolsDisabled}
        icon={IconAdbShellOutline}
        label="ADB Shell"
        onPress={showAdbShellModal}
        role={role}
      />
    </>
  );
};

AdbShellButton.displayName = 'AdbShellButton';

export default AdbShellButton;
